import sp23gbm1 from "./Images/sp23gbm1.png";
import spbonfire from "./Images/sp23bonfire.png";
import sp23studyocial from "./Images/sp23studysocial.png";
import sp23somisocial from "./Images/sp23somisocial.png";
import sp23bf1 from "./Images/sp23bf1.png";
import sp23bf2 from "./Images/sp23bf2.png";
import fa23gbm from "./Images/fa23gbm.png";
import fa23friendsgiving from "./Images/fa23friendsgiving.png";
import fa23yogurtworld from "./Images/fa23yogurtworld.png";
import fa23bonfire from "./Images/fa23bonfire.png";
import fa23bf1 from "./Images/fa23bf1.png";
import fa23bf2 from "./Images/fa23bf2.png";
import fa23gbm1 from "./Images/fa23gbm1.png";
import fa23gbm2 from "./Images/fa23gbm2.png";
import fa23fg1 from "./Images/fa23fg1.png";
import fa23fg2 from "./Images/fa23fg2.png";
import wi24librarywalk from "./Images/wi24librarywalk.png";
import wi24wintergbm from "./Images/wi24wintergbm.png";
import wi24lunarnewyear from "./Images/wi24lunarnewyear.png"
import fa24bonfire from "./Images/fa24bonfire.png";
import fa24friendsgiving from "./Images/fa24friendsgiving.png";
import fa24gamenight from "./Images/fa24gamenight.png";
import fa24gbm from "./Images/fa24gbm.png";
import fa24iceskating from "./Images/fa24iceskating.png"

export const fa24ArchivesData = [
  {
    image: fa24gbm,
    title: "GBM 1",
    date: "October 10, 2024",
    description:
      "We will be hosting our first GBM of the 2024-2025 academic year! Swing by to learn more about what we do, what events we host, and how you can get involved! We will have food for everyone!",
      pic1: '',
      pic2: '',
  },
  {
    image: fa24bonfire,
    title: "Bonfire",
    date: "October 11, 2024",
    description:
      "We will be having a bonfire at La Jolla Shores on Friday (Oct 11) at 6pm!!!! We love our bonfires and seeing everyone at them so come to our first one of this school year and hang out with BURSA!!!! Meet in front of Main Gym at 5:30pm to take the bus with other members! We hope to see you there!!😋🍂🌊",
      pic1: '',
      pic2: '',
  },
  {
    image: fa24gamenight,
    title: "Game Night",
    date: "October 23, 2024",
    description:
      "Happy Week 4!!! We’ll be having a game night for our second GBM of fall quarter ‘24! Join us this Wednesday 10/23 @ 7pm in Price Centers ERC room to destress from midterms and play fun games + enjoy free food!!!!!! 🎲🎮👾🎱",
      pic1: '',
      pic2: '',
  },
  {
    image: fa24iceskating,
    title: "UTC Ice Skating",
    date: "November 16, 2024",
    description:
      "Lace up your skates and glide into a night of fun! Join us for a frosty evening on the ice at our Ice Skating Night on November 16th from 6:30 PM to 9:00 PM. Whether you're a seasoned skater or a first-timer, come enjoy the music, the wintery atmosphere, and the company of friends, as we skate under the twinkling lights.",
      pic1: '',
      pic2: '',
  },
  {
    image: fa24friendsgiving,
    title: "Friendsgiving",
    date: "November 22, 2024",
    description:
      "Join us for a Friendsgiving Feast on November 16th as we come together to celebrate friendship, food, and all the things we're grateful for. This is a potluck-style event, so bring your favorite dish—whether it’s a savory side, a mouthwatering main, or a sweet treat—to contribute to the spread. Whether you’re a kitchen pro or just love to eat, everyone is welcome!",
      pic1: '',
      pic2: '',
  },
]

export const wi24ArchivesData = [
{
  image: wi24librarywalk,
  title: "Tabling",
  date: "January 16th, 2024",
  description:
    "We will be tabling on Library Walk! Swing by to learn more about what we do, what events we host, and how you can get involved! We will have some snacks for everyone!",
    pic1: '',
    pic2: '',
},
{
  image: wi24wintergbm,
  title: "GBM 1",
  date: "January 31st, 2024",
  description:
    "Our first GBM of Winter '24 will be on January 31st! Join the team to learn about Burmese culture, see what events we have planned, and enjoy some Laphet Thoke! Can’t wait to see everyone there! 🍂🫶🏼",
    pic1: '',
    pic2: '',
},
{
  image: wi24lunarnewyear,
  title: "Lunar New Year",
  date: "February 11th, 2024",
  description:
    "BURSA will be tabling at the Lunar New Year festival! We will be handing out cute toys and free food to anyone who visits our booth. Swing by for some free swags and food!",
    pic1: '',
    pic2: '',
},
];

export const fa23ArchivesData = [
  {
    image: fa23gbm,
    title: "GBM 1",
    date: "October 11, 2023 (7:30pm-8:30pm)",
    description:
      "Our first GBM of Fall ‘23 will be this Wednesday, October 11 at the Bear Room (Price Center) from 7:30-8:30pm. Join the team to learn about Burmese culture, see what events we have planned, and enjoy some Laphet Thoke! Can’t wait to see everyone there! 🍂🫶🏼",
    pic1: fa23gbm1,
    pic2: fa23gbm2,
  },
  {
    image: fa23yogurtworld,
    title: "Yogurt World",
    date: "October 24, 2023 (Entire Day)",
    description:
      "Join us on October 24th this Tuesday at YogurtWorld for a sweet collaboration! 🍨🍯 This event will go on for the entire day + BURSA members will be there through 2-3pm if you want to stop by for a quick chat!",
    pic1: '',
    pic2: '',
  },
  {
    image: fa23bonfire,
    title: "Bonfire",
    date: "October 28, 2023 (7:00pm-9:00pm)",
    description:
      "Join us this Friday at La Jolla Shores for a bonfire night! Free food and drinks provided so come hang with BURSA from 7-9pm. If you want to take the bus with members there, then meet in front of Main Gym at 6:30pm!",
    pic1: fa23bf1,
    pic2: fa23bf2,
  },
  {
    image: fa23friendsgiving,
    title: "Friendsgiving",
    date: "November 19, 2023 (8:00pm-11:00pm)",
    description:
      "We’re excited to announce our Friendsgiving event on Sunday, 11/19 at 8:00pm! Bring a dish and join us for a fun night with BURSA members and friends! The RSVP link is in our bio (click the linktree), make sure to sign up by Friday, 11/17! More info will be provided to those who sign up. We hope to see you there! 🍂🍁",
    pic1: fa23fg1,
    pic2: fa23fg2,
  },
];

export const sp23ArchivesData = [
  {
    image: sp23studyocial,
    title: "Study Social",
    date: "May 31, 2023 (6:00pm-10:00pm)",
    description:
      "With finals approaching really soon, it is a great time to come and study with BURSA on May 31st from 6-10pm at John Muir Meeting Room (PC East)! Drop in anytime to get some work done and form study groups with other members! We look forward to seeing your studious selves there! 📚✍🏼",
    pic1: '',
    pic2: '',
  },

  {
    image: sp23somisocial,
    title: "Somi Somi Social",
    date: "May 24, 2023 (7:00pm-9:00pm)",
    description:
      "This Wednesday, May 24th, BURSA will be heading to UTC to get some yummy Somi Somi ice cream from 7:00pm to 9:00pm!!🍦😋 We will be heading to UTC together via the UCSD Central Campus Trolley Station, so meet us there at 6:30pm if you’d like to come with us! Otherwise we’ll see you there!",
    pic1: '',
    pic2: '',
  },
  {
    image: spbonfire,
    title: "Bonfire",
    date: "April 28, 2023 (7:00pm-9:00pm)",
    description:
      "Join BURSA on Friday, April 28th at La Jolla Shores for a bonfire night from 7:00-9:00pm! We’ll have fun activities and snacks, so bring yourself and friends! Also, we will be going as a group with a bus, so if you would like to come with us that way then meet us at 6:30pm in front of Main Gym.",
    pic1: sp23bf1,
    pic2: sp23bf2,
  },
  {
    image: sp23gbm1,
    title: "GBM 1",
    date: "April 19, 2023 (7:00pm-8:00pm)",
    description:
      "BURSA is having our first GBM on Wednesday, April 19th at John Muir College Room (price center east level 2) from 7-8pm💛 Join us to get to know the team, learn about Burmese culture, hear spring quarter announcements, and play games! Hope to see you there!",
    pic1: '',
    pic2: '',
  },
];
